import { Icon } from '@chakra-ui/react';

export default function SFOrgChartIcon(props) {
  return (
    <Icon
      width={6}
      height={6}
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M5.46875 17.1172C4.29688 17.1172 3.60156 16.4297 3.60156 15.2812V12.6406C3.60156 11.4922 4.29688 10.8047 5.46875 10.8047H11.4375V9.67969H5.46875C4.29688 9.67969 3.60156 8.99219 3.60156 7.84375V5.20312C3.60156 4.05469 4.29688 3.36719 5.46875 3.36719H18.5312C19.7031 3.36719 20.3984 4.05469 20.3984 5.20312V7.84375C20.3984 8.99219 19.7031 9.67969 18.5312 9.67969H12.5781V10.8047H18.5312C19.7031 10.8047 20.3984 11.4922 20.3984 12.6406V15.2812C20.3984 16.4297 19.7031 17.1172 18.5312 17.1172H12.5781V18.1953H13.8125C14.3672 18.1953 14.5781 18.7578 14.2344 19.1875L12.4453 21.3984C12.2109 21.6875 11.8203 21.6875 11.5859 21.3984L9.78125 19.1875C9.42188 18.75 9.64062 18.1953 10.2109 18.1953H11.4297V17.1172H5.46875ZM5.49219 8.5H18.5078C18.9531 8.5 19.2188 8.22656 19.2188 7.77344V5.26562C19.2188 4.82031 18.9531 4.54688 18.5078 4.54688H5.49219C5.04688 4.54688 4.78125 4.82031 4.78125 5.26562V7.77344C4.78125 8.22656 5.04688 8.5 5.49219 8.5ZM5.49219 15.9375H18.5078C18.9531 15.9375 19.2188 15.6641 19.2188 15.2188V12.7109C19.2188 12.2578 18.9531 11.9844 18.5078 11.9844H5.49219C5.04688 11.9844 4.78125 12.2578 4.78125 12.7109V15.2188C4.78125 15.6641 5.04688 15.9375 5.49219 15.9375Z'
        fill='currentColor'
      />
    </Icon>
  );
}
